/**
 * useAuthToken Hook
 *
 * Extracts the BetterAuth session token for use with
 * WebSocket authentication (writer_register message).
 * Refreshes on session changes.
 */

import { useSession, getSession } from '../lib/auth-client'
import { useState, useEffect } from 'react'

export function useAuthToken(): string | undefined {
	const { data: session } = useSession()
	const [token, setToken] = useState<string | undefined>()

	useEffect(() => {
		if (!session?.user) {
			setToken(undefined)
			return
		}

		getSession()
			.then((result) => {
				if (result.data?.session?.token) {
					setToken(result.data.session.token)
				}
			})
			.catch((err) => {
				console.error('Failed to fetch auth token:', err)
				setToken(undefined)
			})
	}, [session?.user])

	return token
}
